import React from 'react';
import Icon from '../../../components/AppIcon';

const CommunicationPanel = () => {
  const recentUpdates = [
    {
      id: 1,
      type: 'comment',
      user: 'Sarah Johnson',
      message: 'Completed fire safety inspection documentation',
      taskTitle: 'Annual Fire Safety Inspection',
      timestamp: '2 hours ago',
      avatar: 'SJ'
    },
    {
      id: 2,
      type: 'status',
      user: 'System',
      message: 'Task deadline approaching in 48 hours',
      taskTitle: 'Waste Disposal Permit Renewal',
      timestamp: '5 hours ago',
      avatar: 'SYS'
    },
    {
      id: 3,
      type: 'comment',
      user: 'Michael Brown',
      message: 'Need additional training certificates from HR',
      taskTitle: 'Update Safety Training Records',
      timestamp: '1 day ago',
      avatar: 'MB'
    },
    {
      id: 4,
      type: 'escalation',
      user: 'John Smith',
      message: 'Escalated due to missing documentation',
      taskTitle: 'Waste Disposal Permit Renewal',
      timestamp: '1 day ago',
      avatar: 'JS'
    }
  ];

  const getUpdateIcon = (type) => {
    switch (type) {
      case 'comment':
        return { icon: 'MessageSquare', color: '#3b82f6' };
      case 'status':
        return { icon: 'Bell', color: '#f59e0b' };
      case 'escalation':
        return { icon: 'AlertTriangle', color: '#ef4444' };
      default:
        return { icon: 'Info', color: 'var(--color-muted-foreground)' };
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-1">Recent Activity</h3>
          <p className="text-sm text-muted-foreground">Task updates and communications</p>
        </div>
        <Icon name="MessageCircle" size={20} color="var(--color-muted-foreground)" />
      </div>

      <div className="space-y-4">
        {recentUpdates?.map((update) => {
          const iconConfig = getUpdateIcon(update?.type);
          
          return (
            <div key={update?.id} className="flex items-start gap-3">
              <div className="flex-shrink-0">
                <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center text-xs font-semibold text-primary">
                  {update?.avatar}
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2 mb-1">
                  <p className="text-sm font-medium text-foreground">{update?.user}</p>
                  <Icon name={iconConfig?.icon} size={14} color={iconConfig?.color} />
                </div>
                <p className="text-sm text-muted-foreground mb-1">{update?.message}</p>
                <div className="flex items-center gap-2 text-xs">
                  <span className="text-primary hover:underline cursor-pointer">
                    {update?.taskTitle}
                  </span>
                  <span className="text-muted-foreground">• {update?.timestamp}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <button className="w-full mt-4 inline-flex items-center justify-center gap-2 px-4 py-2 bg-background border border-border rounded-lg hover:bg-muted transition-colors text-sm">
        <Icon name="Plus" size={16} />
        Add Comment
      </button>
    </div>
  );
};

export default CommunicationPanel;